import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {SurgeryRequestItem} from "../types/surgeryRequests";
import {v4 as uuidv4} from "uuid";


const COLLECTION_ID = "surgery_requests"
const databases = new Databases(client);

export const surgeryRequestsService = {
  async list(queries: string[] = [], limit: number = 100): Promise<SurgeryRequestItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      return response.documents.map(doc => doc as unknown as SurgeryRequestItem);

    } catch (error) {
      throw error;
    }
  },
  async createSurgeryRequests(data: SurgeryRequestItem): Promise<SurgeryRequestItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as SurgeryRequestItem;

      return createdItem;
    } catch (error) {
      throw error;
    }
  },

  async updateSurgeryRequest(data: SurgeryRequestItem): Promise<SurgeryRequestItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedSurgeryRequest = await databases.updateDocument(
        database_id,
        COLLECTION_ID,
        id,
        correctData
      ) as unknown as SurgeryRequestItem;

      return updatedSurgeryRequest;
    } catch (error) {
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        COLLECTION_ID,
        id
      );
    } catch (error) {
      throw error;
    }
  },
}